module.exports = __webpack_public_path__ + "static/berlin-night-685debe697b2c4be7d356f695d9a0708.jpg";